module.exports = __webpack_public_path__ + "2acb60f2/img/settings-ico.a214628d.svg";